<div class="dashboard-tabs-container" *ngIf="isTranslationLoaded">
  <qai-tabs (tabSelected)="onTabChange($event)">
    <ng-template
      qaiTab="assignments"
      label="{{ 'reportingV2.ASSIGNMENT_LABEL' | transloco }}"
    >
      <div class="tab-content">
        <app-assignments-tab
          [selectedAccount]="selectedAccount"
          [selectedTeams]="selectedTeams"
          [isTeamAvailable]="isTeamAvailable"
          [isLoading]="isLoading"
          [isNetworkCallInprogress]="isNetworkCallInprogress"
        ></app-assignments-tab>
      </div>
    </ng-template>

    <ng-template
      qaiTab="users"
      label="{{ 'reportingV2.USER_LABEL' | transloco }}"
      *ngIf="showUserTab"
    >
      <div class="tab-content">
        <app-users-tab
          [selectedAccount]="selectedAccount"
          [selectedTeams]="selectedTeams"
        ></app-users-tab>
      </div>
    </ng-template>

    <ng-template
      qaiTab="personalized-practice"
      label="{{ 'reportingV2.PERSONALIZED_PRACTICE_LABEL' | transloco }}"
      *ngIf="showPersonalizedPracticeTab && hasPersonalizedProductsInAnyTeam"
    >
      <div class="tab-content">
        <app-personalized-practice-tab
          [selectedAccount]="selectedAccount"
          [selectedTeams]="selectedTeams"
          [products]="personalProducts"
        ></app-personalized-practice-tab>
      </div>
    </ng-template>
  </qai-tabs>
</div>
